import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const FooterWrap = styled.footer`
  background: ${({ theme }) => theme.colors.nearBlack};
  color: ${({ theme }) => theme.colors.white};
  padding: 4rem 1.5rem 1.5rem;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 0; left: 0; right: 0;
    height: 3px;
    background: linear-gradient(90deg, ${({ theme }) => theme.colors.goldDark}, ${({ theme }) => theme.colors.goldLight}, ${({ theme }) => theme.colors.goldDark});
  }
`;

export const Inner = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1.4fr 1fr 1fr 1.2fr;
  gap: 2.5rem;

  @media (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
    grid-template-columns: 1fr 1fr;
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    grid-template-columns: 1fr;
  }
`;

export const BrandBlock = styled.div`
  .mark {
    display: inline-flex;
    align-items: center;
    gap: 0.75rem;
    margin-bottom: 1rem;

    .dot {
      width: 44px;
      height: 44px;
      border-radius: 50%;
      border: 2px solid ${({ theme }) => theme.colors.gold};
      color: ${({ theme }) => theme.colors.gold};
      font-family: ${({ theme }) => theme.fonts.heading};
      font-weight: 900;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .name {
      font-family: ${({ theme }) => theme.fonts.heading};
      font-weight: 700;
      font-size: 1.4rem;
      color: ${({ theme }) => theme.colors.white};
      letter-spacing: 0.02em;
    }
  }

  p {
    color: rgba(255,255,255,0.65);
    font-size: 0.92rem;
    line-height: 1.7;
  }
`;

export const ColTitle = styled.h4`
  color: ${({ theme }) => theme.colors.goldLight};
  font-family: ${({ theme }) => theme.fonts.heading};
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.2em;
  margin-bottom: 1.25rem;
  position: relative;
  padding-bottom: 0.75rem;

  &::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 28px;
    height: 2px;
    background: ${({ theme }) => theme.colors.gold};
  }
`;

export const LinkCol = styled.div`
  ul { display: flex; flex-direction: column; gap: 0.55rem; }
  a {
    color: rgba(255,255,255,0.75);
    font-size: 0.92rem;
    transition: ${({ theme }) => theme.transitions.base};
    &:hover { color: ${({ theme }) => theme.colors.goldLight}; padding-left: 6px; }
  }
`;

export const FLink = styled(Link)``;

export const ContactCol = styled.div`
  div {
    display: flex;
    align-items: flex-start;
    gap: 0.75rem;
    margin-bottom: 0.85rem;
    font-size: 0.9rem;
    color: rgba(255,255,255,0.78);
    line-height: 1.55;
  }
  svg {
    color: ${({ theme }) => theme.colors.gold};
    margin-top: 4px;
    flex-shrink: 0;
  }
`;

export const Bottom = styled.div`
  max-width: 1200px;
  margin: 3rem auto 0;
  padding-top: 1.5rem;
  border-top: 1px solid rgba(255,255,255,0.08);
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
  font-size: 0.82rem;
  color: rgba(255,255,255,0.55);

  span { color: ${({ theme }) => theme.colors.goldLight}; }
`;
